const home: Record<string, string> = {
  "hero.title1": "CSSBuy Spreadsheet",
  "hero.title2": "2026 Atualizado",
  "hero.title3": "Encontre Produtos Exclusivos",
  "hero.subtitle": "Descubra os melhores CSSBuy spreadsheets atualizados com roupas, sneakers e produtos virais da China com preços baixos e qualidade verificada.",
  "hero.dropdownPlaceholder": "Selecione uma Categoria",
  "hero.cta1": "cssbuy sheet",
  "hero.cta2": "buy it now",
  "about.tag": "Guia CSSBuy 2026",
  "about.title1": "A Melhor Forma de",
  "about.title2": "Encontrar Produtos da China",
  "about.desc": "O cssbuyspreadsheet é uma forma organizada de encontrar produtos da China através de listas atualizadas que incluem roupas streetwear, sneakers, acessórios virais e fornecedores verificados do Weidian e Taobao.",
  "about.feature1": "Listas atualizadas diariamente",
  "about.feature2": "Preços baixos verificados",
  "about.feature3": "Sneakers, roupas e acessórios",
  "about.feature4": "Links diretos para CSSBuy",
  "about.stat1": "5000+",
  "about.stat1Label": "Produtos",
  "about.stat2": "14",
  "about.stat2Label": "Categorias",
  "about.stat3": "2026",
  "about.stat3Label": "Atualizado",
  "about.stat4": "100%",
  "about.stat4Label": "Gratuito",
  "categories.title": "Categorias Populares",
  "categories.subtitle": "Explore nossa coleção completa de produtos organizados por categoria",
  "categories.shoes": "Shoes",
  "categories.hoodies": "Hoodies/Sweaters",
  "categories.tshirts": "T-Shirts",
  "categories.jackets": "Jackets",
  "categories.pants": "Pants/Shorts",
  "categories.headwear": "Headwear",
  "categories.sets": "Sets",
  "categories.underwear": "Underwear/Underpants",
  "categories.jersey": "Jersey",
  "categories.accessories": "Accessories",
  "categories.bags": "Bags",
  "categories.belts": "Belts",
  "categories.perfumes": "Perfumes",
  "categories.other": "Other Stuff",
  "articles.title1": "Artigos &",
  "articles.title2": "Guias",
  "articles.description": "Conteúdo original e otimizado para SEO sobre CSSBuy spreadsheets, guias de compra e comparações. Aprenda a encontrar os melhores produtos da China.",
  "articles.card1.title": "CSSBuy Spreadsheet 2026: Guia Completo Atualizado",
  "articles.card1.desc": "Tudo o que você precisa saber sobre CSSBuy spreadsheets em 2026. Guia passo a passo para iniciantes e avançados.",
  "articles.card1.tag": "Novo",
  "articles.card2.title": "Como Usar CSSBuy Spreadsheet Passo a Passo",
  "articles.card2.desc": "Aprenda a usar planilhas CSSBuy para encontrar produtos incríveis. Tutorial completo para iniciantes.",
  "articles.card3.title": "CSSBuy vs Taobao: Qual é Melhor em 2026?",
  "articles.card3.desc": "Comparação completa entre CSSBuy spreadsheet e busca manual no Taobao. Qual método economiza mais?",
  "articles.readMore": "Ler Artigo",
  "testimonials.tag": "O que dizem",
  "testimonials.rating": "4.9/5.0",
  "testimonials.quote1": "Encontrei sneakers raros em minutos usando esta planilha. A curadoria é incrível e os preços são muito mais baixos que em qualquer outro lugar!",
  "testimonials.name1": "Ricardo Silva",
  "testimonials.location1": "Porto, Portugal",
  "testimonials.quote2": "Melhor recurso para quem compra da China. As planilhas são atualizadas frequentemente e os links sempre funcionam.",
  "testimonials.name2": "Mariana Costa",
  "testimonials.location2": "Lisboa, Portugal",
  "testimonials.quote3": "Comecei a revender produtos encontrados nessas planilhas e o lucro tem sido excelente. Super recomendo!",
  "testimonials.name3": "João Pereira",
  "testimonials.location3": "Braga, Portugal",
  "cta.tag": "Link Oficial",
  "cta.title1": "Acesse agora",
  "cta.title2": "o CSSBuy",
  "cta.title3": "Spreadsheet 2026",
  "cta.heading1": "Pronto para",
  "cta.heading2": "economizar?",
  "cta.description": "Acesse agora o CSSBuy Spreadsheet atualizado 2026 e descubra produtos antes de viralizarem. Listas organizadas, preços baixos e curadoria de qualidade.",
  "cta.button": "buy it now",
};

export default home;